module.exports = __webpack_public_path__ + "static/media/arrow-back-clarnium.cb07c1f0.svg";